<template>
  <div class="org-summary-card" :class="[orgSummaryCardClasses]">
    <div v-if="!loaded">
    <ContentLoader viewBox="0 0 100 100">
      <rect x="0" y="0" rx="3" ry="3" width="250" height="10" />
      <rect x="20" y="20" rx="3" ry="3" width="220" height="10" />
      <rect x="20" y="40" rx="3" ry="3" width="170" height="10" />
      <rect x="0" y="60" rx="3" ry="3" width="250" height="10" />
      <rect x="20" y="80" rx="3" ry="3" width="200" height="10" />
      <rect x="20" y="100" rx="3" ry="3" width="80" height="10" />
    </ContentLoader>
    </div>
    <div v-if="orgData && orgData.ID && loaded">
      <div class="org-summary-card__title h3">Organisation Summary</div>
      <div class="org-summary-card__row">
        <div class="p2-normal">Name</div>
        <div class="p2-extra-bold">{{ orgData.name || "-" }}</div>
      </div>
      <div class="org-summary-card__row">
        <div class="p2-normal">Contact</div>
        <div class="p2-extra-bold">{{ orgData.contact_name || "-" }}</div>
      </div>
      <div class="org-summary-card__hr"></div>
      <div class="org-summary-card__counts">
        <div>
          <div class="org-summary-card__count-desc p2-normal">Apps</div>
          <div class="hero-typography apioshade3--text">{{ orgData.apps || 0 }}</div>
        </div>
        <div>
          <div class="org-summary-card__count-desc p2-normal">Interfaces</div>
          <div class="hero-typography apioshade3--text">{{ orgData.interfaces || 0 }}</div>
        </div>
      </div>
      <div class="org-summary-card__actions" >
        <apio-button v-if="userAdminRights(c)" button-type="secondary" @click="editOrg"
          >Edit organisation</apio-button
        >
        <apio-button v-if="userBuildRights(c)" @click="build">Build</apio-button>
      </div>
    </div>
  </div>

</template>

<script>

import { mapState, mapGetters } from "vuex";

export default {
  name: "OrgSummaryCard",
  props: {
    c: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      loaded: false,
    }
  },
  methods: {
    editOrg() {
      this.$router.push(`/orgs/edit/${this.c}`).catch((e) => {
        console.log(e)
      });
    },
    build() {
      this.$router.push(`/build/?c=${this.c}`);
    },
  },
  async created() {
    await this.$store.dispatch("fetchSingleOrganisation", this.c);
    this.loaded = true;
  },
  computed: {
    ...mapState({
      orgs: (state) => state.orgs.orgs,
      orgData: (state) => state.orgs.currentOrganisation,
    }),
    ...mapGetters(['userBuildRights', 'userAdminRights']),
    isDarkMode() {
      return this.$store.state.mode.darkMode;
    },
    orgSummaryCardClasses() {
      return this.$store.state.mode.darkMode ? 'org-summary-card--dark' : 'org-summary-card--light';
    }
  },
};
</script>

<style lang="scss" scoped>
.org-summary-card {
  width: 292px;
  height: 292px;
  border: 1px solid var(--apio-shade-4);
  border-radius: 4px;
  padding: 16px;

  &__count-desc {
    color: var(--apio-shade-2);
  }

  &--dark {
    background: var(--apio-shade-2);
    color: white;
  }

  &--light {
    color: var(--apio-shade-2);
    background: white;
  }

  @media only screen and (max-width: 600px) {
    width: 320px;
  }

  &__title {
    margin-bottom: 8px;
  }

  &__row {
    display: flex;
    justify-content: space-between;
  }

  &__row:not(:last-of-type) {
    margin-bottom: 4px;
  }

  &__hr {
    height: 1px;
    width: 100%;
    background-color: var(--apio-shade-4);
    margin: 14px 0;
  }

  &__counts {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-bottom: 24px;
  }

  &__actions {
    display: flex;
    justify-content: space-between;
    @media only screen and (max-width: 600px) {
      &
        > button.apio-button.apio-button {
        margin-right: 8px;
      }
      justify-content: flex-start;
    }
  }
}
</style>